import React from "react";
import { motion } from "framer-motion";

const BADGE_CONFIG = {
  buy_fvt:         { label: "רכישה",       color: "#c8f135", bg: "rgba(200,241,53,0.2)" },
  story_or_tweet:  { label: "סטורי / ציוץ", color: "#ff5d68", bg: "rgba(255,93,104,0.2)" },
  repost:          { label: "שיתוף",       color: "#47fffc", bg: "rgba(71,255,252,0.2)" },
  tag_friends:     { label: "תיוג חברים",   color: "#fbbc09", bg: "rgba(251,188,9,0.2)" },
  like_social:     { label: "לייק",        color: "#ff5d68", bg: "rgba(255,93,104,0.2)" },
  likes_on_repost: { label: "לייקים",      color: "#c8f135", bg: "rgba(200,241,53,0.2)" },
  referral:        { label: "הפניה",       color: "#c8f135", bg: "rgba(200,241,53,0.2)" },
};

export default function ProfileTaskCard({ task, onSelect, status, index }) {
  const badge = BADGE_CONFIG[task.task_type] || BADGE_CONFIG.referral;
  const isCompleted = status === "completed";
  const isPending = status === "pending_review";
  const points = task.max_points ? `${task.max_points}+` : `${task.points_per_action}+`;

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.06 }}
      className="rounded-2xl flex items-center gap-6 md:gap-10 px-5 md:px-8"
      style={{
        background: "#050709",
        minHeight: "138px",
        opacity: isCompleted ? 0.5 : 1,
      }}
      dir="rtl"
    >
      {/* Right: task info */}
      <div className="flex-1 py-4">
        <div
          className="inline-flex items-center justify-center px-2.5 py-1 rounded-full text-sm mb-1"
          style={{ background: badge.bg, color: badge.color }}
        >
          {badge.label}
        </div>
        <p className="text-xl font-semibold text-white leading-tight">{task.title}</p>
        <p className="text-base leading-relaxed" style={{ color: "#c4c4c4" }}>{task.description}</p>
      </div>

      {/* Center: points */}
      <div className="flex flex-col items-center gap-1 shrink-0">
        <p className="text-3xl font-bold text-white">{points}</p>
        <p className="text-base" style={{ color: "#c4c4c4" }}>נקודות</p>
      </div>

      {/* Left: action button */}
      <div className="shrink-0">
        {isCompleted ? (
          <div
            className="h-14 w-[122px] rounded-full flex items-center justify-center text-base font-bold"
            style={{ background: "#1a1a1a", color: "#4ade80" }}
          >
            הושלם
          </div>
        ) : isPending ? (
          <div
            className="h-14 w-[122px] rounded-full flex items-center justify-center text-base font-bold"
            style={{ background: "#1a1a1a", color: "#fbbf24" }}
          >
            ממתין
          </div>
        ) : (
          <button
            onClick={() => onSelect(task)}
            className="h-14 w-[122px] rounded-full text-base font-bold transition-all active:scale-95"
            style={{ background: "#1a1a1a", color: "#c8f135" }}
          >
            בצע
          </button>
        )}
      </div>
    </motion.div>
  );
}
